import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CoreUtilsService } from '@src/app/shared/services';
import * as fromStore from '@src/app/store/conventional';
// import { catchError, throwError } from 'rxjs';

export const enrichRequestWithToken = (req: HttpRequest<unknown>, authToken: string | null, noCredentialUrls: string[]): HttpRequest<unknown> => {
  if (noCredentialUrls.includes(req.url)) {
    return req;
  }
  if (Boolean(authToken) && !Boolean(req.headers.has('Authorization'))) {
    const authReq = req.clone({
      setHeaders: { Authorization: `Bearer ${authToken}` }
    });
    return authReq;
  }

  return req;
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const maintenanceModeUrl = inject(CoreUtilsService).getEnvironmentVariable("maintenanceModeUrl") as string ?? '';
  const store = inject(Store<fromStore.State>);
  const authToken = store.selectSignal(fromStore.selectToken)();

  // function handleSessionExpired() {
  //   store.dispatch(fromStore.logoutConfirmed());
  // }

  // function unauthorizedHandler(error: HttpErrorResponse) {
  //   if (error.status === 401) {
  //     handleSessionExpired();
  //   }
  //   return throwError(() => error);
  // }

  return next(enrichRequestWithToken(req, authToken, [maintenanceModeUrl]));
};